import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-activity-icon',
  standalone: true,
  templateUrl: './activity-icon.component.html',
  styleUrls: ['./activity-icon.component.scss']
})
export class ActivityIconComponent {
  @Input() width: number | string = 20;
  @Input() height: number | string = 20;
}
